import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography } from "@mui/material";
import {getVideoByMenuId, upReadCountForVideo} from "../../api/videoApi";
import {format} from "date-fns";

const VideoDetail = ({ menuId }) => {
    const [detailInfo, setDetailInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true); // 초기값을 true로 변경
    const [error, setError] = useState(null); // 1. 에러 상태 추가


    useEffect(() => {
        if (!menuId) { setIsLoading(false); return; }

        const getVideo = async () => {
            setIsLoading(true); // 데이터를 새로 가져올 때마다 로딩 시작
            setError(null); // 이전 에러 상태 초기화
            try {
                const videoData = await getVideoByMenuId(menuId);
                const formattedDate = format(new Date(videoData.updateDate), 'yyyy-MM-dd');
                setDetailInfo({
                    ...videoData,
                    updateDate: formattedDate
                });

                upReadCountForVideo(menuId);
            } catch (error) {
                setDetailInfo(null);
                setError("비디오 정보를 불러오는 데 실패했습니다.");
            } finally {
                setIsLoading(false);
            }
        };
        getVideo();
    }, [menuId]);

    // 4. 로딩 중일 때 UI
    if (isLoading) {
        return <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography>로딩 중...</Typography>
        </Box>;
    }

    // 5. 에러가 발생했을 때 UI
    if (error) {
        return <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/*<Typography color="error">{error}</Typography>*/}
            <Typography>동영상 매뉴얼을 준비 중입니다.</Typography>
        </Box>;
    }

    // 6. 데이터가 없을 때 UI (로딩과 에러가 모두 아닌 경우)
    if (!detailInfo) {
        return <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography>동영상 매뉴얼을 준비 중입니다.</Typography>
        </Box>;
    }

    let element = <>
        <Typography variant="h6" sx={{mb: 1}}>
            {detailInfo.videoTitle} 매뉴얼
        </Typography>
        <Box sx={{mb: 1}}>
            <Typography variant="body2" color="text.secondary">
                등록일: {detailInfo.updateDate} | 조회수: {detailInfo.readCount}
            </Typography>
        </Box>
        <Divider sx={{mb: 2}}/>
        <video
            key={menuId} // ID가 바뀔 때마다 비디오를 새로 로드하기 위함
            src={`/videos/${detailInfo.videoFileName}.mp4`}
            controls
            autoPlay
            style={{width: '100%', height: '100%', minHeight: 600, borderRadius: '4px'}}
        />
        <Box sx={{mt: 3, mx: 1}}>
            <Typography sx={{mb: 1}}>
                {detailInfo.videoTitle} 메뉴의 동영상 매뉴얼입니다.<br/><br/>
                이 영상에서는 {detailInfo.videoTitle} 메뉴의 주요기능에 대해 안내해드리고 있으며,<br/> 보다 자세한 문의사항은 에잇핀으로 문의주시기 바랍니다.<br/><br/>
                감사합니다.
            </Typography>
            {/* 첨부파일 다운로드 공간 */}
            {/*<Box sx={{border: '2px solid skyblue', width: '100%', height: '50px', borderRadius: '5px'}}></Box>*/}
        </Box>
    </>;
    return element;
}

export default VideoDetail;